import * as React from 'react';
import PictureList from 'ui-components/PictureList';
import * as CONSTANTS from '../constants';
import ErrorBoundary from 'ui-components/ErrorBoundary';
import Credits from 'components/Credits';
import {Fader} from 'ui-components/animations';
import Work from 'types/Work';

interface StyleObject{
	[index: string]: string;
}
interface AdditionsProps{
	navigateTo: (url: string) => void;
	works: Work[];
}
interface State{
	hovering: Work;
}

export class Additions extends React.Component<AdditionsProps, State>{
	
	public cachedBorders: any;

	constructor(props){
		super(props);
		this.cachedBorders = {};
		this.state = {hovering: null};
	}

	onClick = work => {
		this.props.navigateTo(
			`/gallery/${work.id}`
		);
	}

	getImgStyle = ({
		image,
		idx,
		firstOnLine,
		lastOnLine
	}) => {
		let cache = this.cachedBorders;
		if (!cache[image.id]){
			cache[image.id] = Math.floor(
				Math.random() * CONSTANTS.ADDITIONS_MAX_BORDER_WIDTH
			);
		}
		let border = cache[image.id];

		let style: StyleObject = {
			border: `${border}px white solid`,
		};
		if (firstOnLine){
			style.borderLeftWidth = '0';
		}
		if (lastOnLine){
			style.borderRightWidth = '0';
		}
		return style;
	}

	setHover = (w) => {
		let {hovering} = this.state;
		if (!hovering || hovering.id !== w.id){
			this.setState({hovering: w});
		}
	}
	
	clearHover = () => {
		this.setState({hovering: null});
	}

	render(){
		let {works} = this.props;
		let {hovering} = this.state;
		return (
			<div className="grid">
				<ErrorBoundary>
					<PictureList
						pictureRoot={CONSTANTS.ART_DIRECTORY}
						pictures={works}
						onClick={this.onClick}
						onMouseEnter={this.setHover}
						onMouseLeave={this.clearHover}
						extraWidth={4}
						extraHeight={4}
						styleFunc={
							CONSTANTS.ADDITIONS_RANDOM_BORDERS
							? this.getImgStyle
							: undefined
						}
					/>
				</ErrorBoundary>
				<Fader>{hovering && (
					<Credits
						work={hovering}
						visibleOnPropsChange={true}
						delay={0}
					/>
				)}</Fader>
			</div>
		);
	}

}
export default Additions;